export const REQUEST = 'Admin/Reports/REQUEST';
export const SUCCESS = 'Admin/Reports/SUCCESS';
export const ERROR = 'Admin/Reports/ERROR';

export const SET = 'Admin/Reports/SET';
export const DELETED = 'Admin/Reports/DELETED';
export const ADDED = 'Admin/Reports/ADDED';
export const UPDATED = 'Admin/Reports/UPDATED';
